import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth, RequireInitializedMember } from 'routes/utils';

const CardRead =       lazy(() => import(/* webpackChunkName: "card-read" */ 'pages/card/read'));
const CardShareView =  lazy(() => import(/* webpackChunkName: "card-share" */ 'pages/card/share'));
const CardSignView =   lazy(() => import(/* webpackChunkName: "card-sign-view" */ 'pages/card/sign/view'));
const PrintView =      lazy(() => import(/* webpackChunkName: "reminders-print-view" */ 'pages/my-reminders/print-view'));
const CardSendCreate = lazy(() => import(/* webpackChunkName: "card-send-create" */ 'pages/card/send/create'));

const renderCleanRoutes = () => [
  <Route
    key="card-send-create"
    name="card-send-create"
    path="/card/send/create"
    element={
      <RequireInitializedMember>
        <CardSendCreate/>
      </RequireInitializedMember>
    }
  />,
  <Route
    key="card-read"
    name="card-read"
    path="/card/read/:magicLink"
    element={<CardRead />}
  >
    <Route
      key="card-read-long"
      name="card-read-long"
      path=":magicLink2"
      element={<CardRead />}
    />
  </Route>,
  <Route
    key="card-share-view"
    name="card-share-view"
    path="/card/share/view/:magicLink"
    element={<CardShareView />}
  >
    <Route
      key="card-share-view-long"
      name="card-share-view-long"
      path=":magincLink2"
      element={<CardShareView />}
    />
  </Route>,
  <Route
    key="card-sign-view"
    name="card-sign-view"
    path="/card/sign/view/:magicLink"
    element={<CardSignView/>}
  >
    <Route
      key="card-sign-view-long"
      name="card-sign-view-long"
      path=":magicLink2"
      element={<CardSignView/>}
    />,
  </Route>,
  <Route
    key="reminders-print-view"
    name="reminders-print-view"
    path="/reminders-print-view"
    element={
      <RequireAuth redirectTo="/login?next=/reminders-print-view" strict>
        <PrintView/>
      </RequireAuth>
    }
  />
];


export default renderCleanRoutes;
